module.exports = __webpack_public_path__ + "img/CR.91784dc5.svg";